import React, { useMemo } from "react";
import "maplibre-gl/dist/maplibre-gl.css";
import { TrackingProvider, ProductNames } from "@local-logic/core/tracking";
import { useStateManagerContext } from "~/context/stateManager";
import useIsMobile from "~/hooks/useIsMobile";
import { useFlags } from "launchdarkly-react-client-sdk";
import { SDKProps } from "~/types";
import { LocalContentProvider } from "./context";
import Map from "./components/Map";

const LocalContent = () => {
  const { sdkState } = useStateManagerContext<SDKProps>();
  const flags = useFlags();
  const isMobile = useIsMobile();

  const meta = useMemo(() => {
    const clientKey = sdkState.apiKey?.split(".") ?? "";

    return {
      productVersion: FULL_APP_VERSION,
      productName: ProductNames.LOCAL_CONTENT,
      clientId: clientKey[0].slice(3),
    };
  }, []);

  return (
    <TrackingProvider
      trackEvents={flags.eventTracking}
      analyticsTracker={flags.mixpanelTracking && "mixpanel"}
      analyticsDebugMode={import.meta.env.MODE !== "production"}
      apiKey={sdkState.apiKey}
      meta={meta}
      attributes={{
        location: {
          lat: sdkState.options?.lat,
          lng: sdkState.options?.lng,
        },
        host_url: document.referrer,
        locale: sdkState.globalOptions?.locale,
        isMobile,
      }}
    >
      <LocalContentProvider>
        <Map />
      </LocalContentProvider>
    </TrackingProvider>
  );
};

export default LocalContent;
